import fetch, { NewAxiosRequestConfig } from '@/utils/axios';
import Constants from '@/constants/const';
import { getValueFromCookie } from '@/utils/cookie';
import { isSayWeeeApp } from '@/utils/common/device';

/**
 * 获取上报token
 * @param config
 */
export const getTrackSession = (source, url, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  const ctx = config?.ctx;
  const params: Record<string, string | number> = { source, url };
  if (!getValueFromCookie(Constants.B_COOKIE, ctx) && !isSayWeeeApp(ctx)) {
    params.first_time_launch = 1;
  }
  return fetch.get('/ec/tracking/session_id', params, config);
};
